<script setup lang="ts">
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
</script>

<template>
  <el-config-provider :locale="zhCn">
    <div class="router-view">
      <router-view></router-view></div
  ></el-config-provider>
</template>

<style scoped lang="less">
.router-view {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
